import React from "react";
import { IClientId } from "../../Client.props";
import EditClient from "./EditClient";



const EditClientIndex: React.FC<IClientId> = ({ clientId ,setMethod}) => {

    return (
        <EditClient clientId={clientId} setMethod={setMethod}/>
    );
}

export default EditClientIndex;
